export default "﻿<div>\r\n    <div data-bind=\"control: { uiGenerator: 'Link', viewModel: viewModel.link }\"></div>\r\n</div>"